import axios from './axios';
import { getConfig } from '../utils/sessionStorageUtils';

export const getCollections = async (pageIndex: string) => {
  try {
    const result = await axios.get(`/Group/${pageIndex}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCollectionProducts = async (id: string) => {
  try {
    const result = await axios.get(`/Group/${id}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const postCollectionProduct = async (data: { groupId: string; deallerCodes: string[] }) => {
  try {
    const result = await axios.post(`/Group/addRange`, data, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const postCollection = async (data: { name: string }) => {
  try {
    const result = await axios.post(`/Group`, data, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteCollections = async (groupId: string[]) => {
  try {
    const result = await axios.delete(`/Group`, getConfig(groupId));
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteCollectionProducts = async (groupId: string, data: string[]) => {
  try {
    const result = await axios.delete(`/Group/removeRage/${groupId}`, getConfig(data));
    return result.data;
  } catch (e) {
    console.error(e);
  }
};
